import { apiRequest } from '../client'

export type InventoryHistoryItem = {
  eventKind: 'movement' | 'reservation'
  eventType: string
  sku: string
  deltaQty?: number | null
  availableAfter?: number | null
  reservedAfter?: number | null
  restaurantId?: number | null
  reference?: string | null
  note?: string | null
  createdBy?: string | null
  operatorId?: string | null
  stationId?: string | null
  hubId?: number | null
  createdAt?: string | null
  orderId?: string | null
  movementId?: number | null
  clientRef?: string | null
  /**
   * CHG-2026-09-stock-usage-and-price-twins (D7): the sold product that caused this line when it
   * differs from the stock article (a dish or variant); omitted otherwise. Quantities are
   * decimal numbers (up to 3 decimals) in the article's base unit.
   */
  soldSku?: string
  soldName?: string
}

export type InventoryHistoryResponse = {
  items: Array<InventoryHistoryItem>
  total: number
  page: number
  pageSize: number
}

export const inventoryHistoryApi = {
  list: (params: {
    restaurantId?: number | null
    sku?: string
    from?: string
    to?: string
    eventKind?: 'movement' | 'reservation' | 'all'
    eventType?: string
    /**
     * Scope the timeline to one movement reference, e.g. `delivery:<uuid>` for the RECEIVE a
     * booked delivery created.
     */
    reference?: string
    page?: number
    pageSize?: number
    sortBy?: string
    sortDir?: 'asc' | 'desc'
  }) => {
    const sp = new URLSearchParams()
    if (params.restaurantId != null)
      sp.set('restaurantId', String(params.restaurantId))
    if (params.sku) sp.set('sku', params.sku)
    if (params.from) sp.set('from', params.from)
    if (params.to) sp.set('to', params.to)
    if (params.eventKind && params.eventKind !== 'all')
      sp.set('eventKind', params.eventKind)
    if (params.eventType) sp.set('eventType', params.eventType)
    if (params.reference) sp.set('reference', params.reference)
    if (params.page != null) sp.set('page', String(params.page))
    if (params.pageSize != null) sp.set('pageSize', String(params.pageSize))
    if (params.sortBy) sp.set('sortBy', params.sortBy)
    if (params.sortDir) sp.set('sortDir', params.sortDir)
    return apiRequest<InventoryHistoryResponse>(
      `/api/v0/admin/inventory/history?${sp.toString()}`,
    )
  },
}
